/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsanswerlabel3Inputs */

const en_openquestionsanswerlabel3 = /** @type {(inputs: Openquestionsanswerlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your answer:`)
};

const pt_openquestionsanswerlabel3 = /** @type {(inputs: Openquestionsanswerlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua resposta:`)
};

/**
* | output |
* | --- |
* | "Your answer:" |
*
* @param {Openquestionsanswerlabel3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsanswerlabel3 = /** @type {((inputs?: Openquestionsanswerlabel3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsanswerlabel3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsanswerlabel3(inputs)
	return pt_openquestionsanswerlabel3(inputs)
});
export { openquestionsanswerlabel3 as "openQuestionsAnswerLabel" }